import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/noData_empty.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-77182ac0")

_pushScopeId("data-v-77182ac0")
const _hoisted_1 = { class: "flex gap-2" }
const _hoisted_2 = {
  id: "hanging-table",
  class: "flex-1 rounded-xl overflow-hidden border border-red-200 "
}
const _hoisted_3 = { class: "hanging-table-header p-2 flex items-center text-sm gap-2 border-b border-red-200" }
const _hoisted_4 = { class: "bg-red-500 text-white px-3 py-1.5 line-height-1 rounded-full font-bold" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "separator" }, null, -1)
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "separator" }, null, -1)
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "px-3 py-4 flex items-center text-xs gap-2 font-semibold border-b border-red-200" }
const _hoisted_10 = { class: "w-10 shrink-0 text-center" }
const _hoisted_11 = { class: "w-60" }
const _hoisted_12 = { class: "flex-1" }
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "w-10 shrink-0 text-center" }
const _hoisted_16 = { class: "w-60 flex flex-col gap-0.5" }
const _hoisted_17 = { class: "flex gap-2 items-center" }
const _hoisted_18 = { class: "day-pill px-2 py-0.5 rounded-sm" }
const _hoisted_19 = {
  class: "text-gray-500 font-light",
  style: {"font-size":"10px"}
}
const _hoisted_20 = { class: "flex-1 font-bold" }
const _hoisted_21 = { class: "flex-1" }
const _hoisted_22 = {
  class: "px-1 py-0.5 rounded-full bg-gray-100 text-gray-500 font-semibold",
  style: {"font-size":"10px"}
}
const _hoisted_23 = { class: "flex-1" }
const _hoisted_24 = {
  key: 1,
  class: "px-3 py-2 flex items-center text-xs gap-2"
}
const _hoisted_25 = { class: "w-full flex items-center justify-center flex-col gap-4 py-6" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "empty",
  class: "h-28"
}, null, -1)
const _hoisted_27 = { class: "text-sm text-gray-700 font-semibold" }
const _hoisted_28 = {
  id: "non-hanging-table",
  class: "flex-1 rounded-xl overflow-hidden border border-green-200 "
}
const _hoisted_29 = { class: "non-hanging-table-header p-2 flex items-center text-sm gap-2 border-b border-green-200" }
const _hoisted_30 = { class: "bg-green-500 text-white px-3 py-1.5 line-height-1 rounded-full font-bold" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "separator" }, null, -1)
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "separator" }, null, -1)
const _hoisted_34 = { class: "font-bold" }
const _hoisted_35 = { class: "px-3 py-4 flex items-center text-xs gap-2 font-semibold border-b border-green-200" }
const _hoisted_36 = { class: "w-10 shrink-0 text-center" }
const _hoisted_37 = { class: "w-60" }
const _hoisted_38 = { class: "flex-1" }
const _hoisted_39 = { class: "w-10 shrink-0 text-center" }
const _hoisted_40 = { class: "w-60 flex flex-col gap-0.5" }
const _hoisted_41 = { class: "flex gap-2 items-center" }
const _hoisted_42 = {
  class: "text-gray-500 font-light",
  style: {"font-size":"10px"}
}
const _hoisted_43 = { class: "flex-1" }
const _hoisted_44 = {
  class: "px-1 py-0.5 rounded-full bg-gray-100 text-gray-500 font-semibold",
  style: {"font-size":"10px"}
}
const _hoisted_45 = {
  key: 1,
  class: "px-3 py-2 flex items-center text-xs gap-2"
}
const _hoisted_46 = { class: "w-full flex items-center justify-center flex-col gap-4 py-6" }
const _hoisted_47 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "empty",
  class: "h-28"
}, null, -1)
const _hoisted_48 = { class: "text-sm text-gray-700 font-semibold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("cariStt.table.hanging")), 1),
        _hoisted_5,
        _createVNode("span", null, _toDisplayString(_ctx.$t("cariStt.table.totalStt")), 1),
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.summary.hanging.totalStt), 1),
        _hoisted_7,
        _createVNode("span", null, _toDisplayString(_ctx.$t("cariStt.table.totalKoli")), 1),
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.summary.hanging.totalPieces), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("cariStt.table.no")), 1),
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("cariStt.table.noStt")), 1),
        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("cariStt.table.lastLocation")), 1),
        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("cariStt.table.lastStatus")), 1),
        _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("cariStt.table.note")), 1)
      ]),
      (_ctx.hangingData.length > 0)
        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.hangingData, (hanging, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "px-3 py-2 flex items-center text-xs gap-2",
              key: index
            }, [
              _createVNode("div", _hoisted_15, _toDisplayString(1 + index), 1),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("strong", null, _toDisplayString(hanging.sttNo), 1),
                  _createVNode("span", _hoisted_18, _toDisplayString(hanging.daysHanging) + " " + _toDisplayString(_ctx.$t("cariStt.table.days")), 1)
                ]),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDateToString(hanging.lastScanAt)), 1)
              ]),
              _createVNode("div", _hoisted_20, _toDisplayString(hanging.scanLocation), 1),
              _createVNode("div", _hoisted_21, [
                _createVNode("span", _hoisted_22, _toDisplayString(hanging.lastStatus), 1)
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("div", null, _toDisplayString(hanging.note), 1)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.hangingData.length === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("cariStt.table.emptyState")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_28, [
      _createVNode("div", _hoisted_29, [
        _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("cariStt.table.nonHanging")), 1),
        _hoisted_31,
        _createVNode("span", null, _toDisplayString(_ctx.$t("cariStt.table.totalStt")), 1),
        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.summary.nonHanging.totalStt), 1),
        _hoisted_33,
        _createVNode("span", null, _toDisplayString(_ctx.$t("cariStt.table.totalKoli")), 1),
        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.summary.nonHanging.totalPieces), 1)
      ]),
      _createVNode("div", _hoisted_35, [
        _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("cariStt.table.no")), 1),
        _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("cariStt.table.noStt")), 1),
        _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("cariStt.table.lastStatus")), 1)
      ]),
      (_ctx.nonHangingData.length > 0)
        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.nonHangingData, (nonHangingItem, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "px-3 py-2 flex items-center text-xs gap-2",
              key: index
            }, [
              _createVNode("div", _hoisted_39, _toDisplayString(1 + index), 1),
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _createVNode("strong", null, _toDisplayString(nonHangingItem.sttNo), 1)
                ]),
                _createVNode("div", _hoisted_42, _toDisplayString(_ctx.formatDateToString(nonHangingItem.lastScanAt)), 1)
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("span", _hoisted_44, _toDisplayString(nonHangingItem.lastStatus), 1)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.nonHangingData.length === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_45, [
            _createVNode("div", _hoisted_46, [
              _hoisted_47,
              _createVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("cariStt.table.emptyState")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})